export default function MessageQuestionIcon({
  color = '#878F9B',
  width = '20',
  height = '20',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.66602 18.5979C6.43268 18.5979 6.191 18.5396 5.97433 18.4229C5.49933 18.1729 5.20768 17.6729 5.20768 17.1396V15.9563C2.69102 15.698 1.04102 13.8479 1.04102 11.1979V6.19792C1.04102 3.33125 2.96602 1.40625 5.83268 1.40625H14.166C17.0327 1.40625 18.9577 3.33125 18.9577 6.19792V11.1979C18.9577 14.0646 17.0327 15.9896 14.166 15.9896H11.0243L7.47432 18.3563C7.23266 18.5146 6.94935 18.5979 6.66602 18.5979ZM5.83268 2.64791C3.68268 2.64791 2.29102 4.03958 2.29102 6.18958V11.1896C2.29102 13.3396 3.68268 14.7313 5.83268 14.7313C6.17435 14.7313 6.45768 15.0146 6.45768 15.3563V17.1313C6.45768 17.2396 6.52435 17.2896 6.56602 17.3146C6.60769 17.3396 6.69102 17.3646 6.78269 17.3063L10.491 14.8396C10.591 14.773 10.716 14.7313 10.841 14.7313H14.1743C16.3243 14.7313 17.716 13.3396 17.716 11.1896V6.18958C17.716 4.03958 16.3243 2.64791 14.1743 2.64791H5.83268Z'
        fill={color}
      />
      <path
        d='M10.0005 10.0899C9.65882 10.0899 9.37549 9.80654 9.37549 9.46488V9.28988C9.37549 8.32321 10.0838 7.8482 10.3505 7.66487C10.6588 7.45654 10.7588 7.31488 10.7588 7.09821C10.7588 6.68154 10.4172 6.33984 10.0005 6.33984C9.58382 6.33984 9.24215 6.68154 9.24215 7.09821C9.24215 7.43988 8.95882 7.72321 8.61715 7.72321C8.27552 7.72321 7.99219 7.43988 7.99219 7.09821C7.99219 5.98988 8.89215 5.08984 10.0005 5.08984C11.1088 5.08984 12.0088 5.98988 12.0088 7.09821C12.0088 8.04821 11.3088 8.52321 11.0505 8.69821C10.7255 8.91488 10.6255 9.05654 10.6255 9.28988V9.46488C10.6255 9.81488 10.3422 10.0899 10.0005 10.0899Z'
        fill={color}
      />
      <path
        d='M10 12.168C9.65 12.168 9.375 11.8846 9.375 11.543C9.375 11.2013 9.65833 10.918 10 10.918C10.3417 10.918 10.625 11.2013 10.625 11.543C10.625 11.8846 10.35 12.168 10 12.168Z'
        fill={color}
      />
    </svg>
  );
}
